<template>
  <div
    class="common-image-video-block"
    ref="block"
    :class="{
      'is-hover': isHover,
      'is-alternative': alternative,
    }"
  >
    <!-- Content -->
    <div class="common-image-video-block__content is-rounded-wrap">
      <div
        class="common-image-video-block__content__preview"
        data-animate="block-image-preview"
      >
        <WidgetPicture
          class="is-cover"
          :image="{ custom: props.item?.image?.responsiveImage }"
          :lazyLoad="true"
          :alt="props.item?.image?.responsiveImage?.alt"
        />
      </div>
      <div
        v-if="props.item?.linkVideo !== ''"
        class="common-image-video-block__content__video"
        data-animate="block-video-preview"
      >
        <WidgetVideo
          class="is-cover"
          :videoUrl="props.item?.linkVideo"
          :loop="true"
          :forcePlay="true"
          :autoplay="true"
          :muted="true"
          :preload="'auto'"
          :playInViewport="true"
          @play="onViewportEnter"
          @pause="onViewportLeave"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonImageVideoBlock',
}
</script>

<script setup>
import { gsap } from 'gsap'

const props = defineProps({
  item: Object,
  alternative: Boolean,
  retination: Boolean,
})

const block = ref(null)

const isHover = ref(false)
const touch = ref(false)

const duration = 0.6
const durationFast = 0.4
const ease = 'power2.inOut'

const hasPreview = computed(() => props.item?.linkVideo)

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints /// !! trasformano 0/1 in Bool
})

const onMouseEnter = () => {
  if (touch.value) return false

  const parent = block.value
  const video = parent?.querySelector('[data-animate="block-video-preview"]')

  isHover.value = true

  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 1, duration, ease })
  }
}

const onMouseLeave = () => {
  if (touch.value) return false

  const parent = block.value
  const video = parent?.querySelector('[data-animate="block-video-preview"]')

  isHover.value = false

  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 0, duration, ease })
  }
}

const onViewportEnter = () => {
  const parent = block.value
  const video = parent?.querySelector('[data-animate="block-video-preview"]')

  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 1, duration, ease })
  }
}

const checkMouseLeave = () => {
  if (hasPreview.value) {
    return
  } else onMouseLeave()
}

const onViewportLeave = () => {
  const parent = block.value
  const video = parent?.querySelector('[data-animate="block-video-preview"]')

  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 0, duration, ease })
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
